// src/components/Header.jsx
import React from 'react';
import { useTranslation } from 'react-i18next';
import UserMenu from './UserMenu';

const Header = ({
  showCatalogButton = true,
  onRefresh,
}) => {
  const { t } = useTranslation();

  const handleListClick = () => {
    window.location.hash = '#list';
  };

  const handleCatalogClick = () => {
    window.location.hash = '#catalog';
  };

  const isListActive = showCatalogButton;
  const isCatalogActive = !showCatalogButton;

  return (
    <div className="bg-white shadow-sm border-b border-gray-200 pl-4 pr-3 py-[12px] shadow">
      <div className="flex justify-between items-center">
        <div className="flex items-center space-x-1">
          <button
            onClick={handleListClick}
            className={`px-3 py-1.5 rounded-lg flex items-center space-x-2 transition-colors ${
              isListActive
                ? 'bg-purple-600 text-white'
                : 'bg-white text-gray-700 hover:bg-gray-200'
            }`}
          >
            <i className="fas fa-shopping-cart"></i>
            <span className="font-medium">{t('nav.list')}</span>
          </button>

          <button
            onClick={handleCatalogClick}
            className={`px-3 py-1.5 rounded-lg flex items-center space-x-2 transition-colors ${
              isCatalogActive
                ? 'bg-purple-600 text-white'
                : 'bg-white text-gray-700 hover:bg-gray-200'
            }`}
          >
            <i className="fas fa-book"></i>
            <span className="font-medium">{t('nav.catalog')}</span>
          </button>
        </div>

        <div className="flex items-center space-x-2">
          <button
            onClick={onRefresh}
            className="flex flex-col items-center text-gray-600"
            aria-label={t('header.refresh')}
            title={t('header.refresh')}
          >
            <div className="w-9 h-9 rounded-full flex items-center justify-center hover:bg-gray-100 transition-colors">
              <i className="fas fa-sync-alt text-xl"></i>
            </div>
          </button>

          <UserMenu />
        </div>
      </div>
    </div>
  );
};

export default Header;
